export enum StaffTableTabNames {
  'Questions Submitted' = 'submitted_count',
  'Questions Rejected' = 'rejected_count',
  'Questions Published' = 'published_count',
  'Questions Factchecked' = 'factchecked_count',
  'Full Name' = 'full_name',
}
